import React, { FC } from 'react'

import { contentTypeOf } from 'data/src/utils/contentfulPages'

import { ImageBlock, PlaceholderBlock, RichTextBlock, HeroBlock, RedHotBannerBlock, SocialMediaPostBlock } from '.'
import {
  BlockTypes,
  ContentfulBlock,
  HeroBlockFields,
  ImageBlockFields,
  RichTextBlockFields,
  RedHotBannerBlockFields,
  SocialMediaPostBlockFields,
} from './types'

interface BlockProps {
  block: ContentfulBlock<any>
}

export const Block: FC<BlockProps> = ({ block }) => {
  switch (contentTypeOf(block)) {
    case BlockTypes.RICH_TEXT_BLOCK:
      return <RichTextBlock fields={block.fields as RichTextBlockFields} />
    case BlockTypes.IMAGE_BLOCK:
      return <ImageBlock fields={block.fields as ImageBlockFields} />
    case BlockTypes.HERO_BLOCK:
      return <HeroBlock fields={block.fields as HeroBlockFields} />
    case BlockTypes.RED_HOT_BANNER:
      return <RedHotBannerBlock fields={block.fields as RedHotBannerBlockFields} />
    case BlockTypes.SOCIAL_MEDIA_POST:
      return <SocialMediaPostBlock fields={block.fields as SocialMediaPostBlockFields} />
    default:
      return <PlaceholderBlock block={block} />
  }
}
